"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_EXPOSURE_TRIGGER_NAME = exports.WIDGET_NAME_PHASE_0 = exports.BI_BOOKINGS_USER_OF_USER_END_POINT = exports.BI_BOOKINGS_SRC = exports.WIDGET_BI_REFERRAL = void 0;
exports.WIDGET_BI_REFERRAL = {
    WIDGET: 'widget',
    WIDGET_IMAGE: 'widget_image',
    WIDGET_TITLE: 'widget_title',
    WIDGET_DESCRIPTION: 'widget_description',
    WIDGET_BUTTON: 'widget_button',
};
exports.BI_BOOKINGS_SRC = 16;
exports.BI_BOOKINGS_USER_OF_USER_END_POINT = 'wixboost-ugc';
exports.WIDGET_NAME_PHASE_0 = 'widget-phase-zero';
exports.BI_EXPOSURE_TRIGGER_NAME = 'widget_viewer_opened';
//# sourceMappingURL=bi.const.js.map